/**
 * Convert.com experiences and goals. These are configured/created on convert.com and then defined here for usage.
 */
export const goals = {
  active: {
    /**
     * Defined list of goals which can be triggered.
     * A convert.com goal must be defined here along with its triggerConversion code before it can be used.
     */
    created_payment_link: ['triggerConversion', '100216541'],
    landing_conversion: ['triggerConversion', '100212559'],
    reached_review_order: ['triggerConversion', '100218832'],
  },
  testing: [
    /**
     * Array of strings. Each entry refers to a convert.com 'active' goal that is allowed to run on
     * non-production environments (defined above).
     */
  ],
};

export const experiences = {
  active: {
    /**
     * List of active experiences
     */
    // buyer_landing_ab: {
    //   trackAs: 'e015',
    //   defaultVariation: 'variation1',
    // },
  },
  testing: [
    /**
     * Array of strings. Each entry refers to a convert.com 'active' experience js condition that is allowed to run on
     * non-production environments (defined above).
     */
  ],
};
